Monitoring.Views ||= {}

class Monitoring.Views.GenericSocialContentView extends Backbone.View
  showAudio: (evt) ->
    id = evt.currentTarget.id
    modalId = id.replace(/preview/, 'modal')
    @$el.find('#' + modalId).modal()

  pauseAudio: ->
    audio.pause() for audio in @$el.find('audio')

  showVideo: (evt) ->
    id = evt.currentTarget.id
    modalId = id.replace(/preview/, 'modal')
    @$el.find('#' + modalId).modal()

  pauseVideo: ->
    video.pause() for video in @$el.find('video')

  onDetach: ->

  onAttach: ->

  removeReplyButton: ->

  removeCutTicketButton: ->
